import Drawer from "../../../assets/vfx/drawer/drawer";
import QuestionSection from "./questionSection";
import { DeviceQuestionnaireResponseDto } from "../../../services/dto";

interface QuestionnaireResponseViewProps {
    data: DeviceQuestionnaireResponseDto[] | undefined;
    show: boolean;
    onHide: () => void;
}

export const QuestionnaireResponseView = (props: QuestionnaireResponseViewProps) => {
   
    const groupedData = props.data?.reduce((acc: any, curr: any) => {
        const { sectionId, section, options, answers, otherAnswers, question } = curr;

        let sectionWiseData = acc.find((s: any) => s.sectionId === sectionId);
        if (!sectionWiseData) {
            sectionWiseData = {
                sectionId,
                section,
                questiondata: [],
            };
            acc.push(sectionWiseData);
        } 

        sectionWiseData.questiondata.push({
            question,
            options,
            answers,
            otherAnswers
        });

        return acc;
    }, []);

  return (
    <>
      <Drawer.View
        className="w-90"
        show={props.show}
        backdrop={true}
        placement="end"
        scroll={true}
        onHide={() => props.onHide()}
        onEdit={undefined}
        title={"View Form"}
        onDeactivate={undefined}
        showDeativateOnHeader={true}
      >
              <section className="program-groups">
                  <div>
                      {groupedData.map((section: any) => (
                          
                          <div key={section.sectionId} style={{ marginBottom: "30px" }}>
                              <h2>{section.section}</h2>
                              {
                                  section.questiondata.map((q: any, index: any) => (
                                      <QuestionSection question={q.question} answerText={q.answers} otherAnswerText={q.otherAnswers} questionOptions={ q.options} />

                             ))
                              }
                          </div>
                      ))}
                  </div>

                  
              </section>
      </Drawer.View>
    </>
  );
};
